import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import swal from "sweetalert";
import "react-dropdown-tree-select/dist/styles.css";
import BackBtn from "../../common/BackBtn";
import { HomeIcon } from "../../assets/Icons";

class EditRangeBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      question: "",

      maxRange: "",
      minRange: "",
    };
  }

  onChangeInput = (e) => {
    e.preventDefault();

    this.setState({ [e.target.name]: e.target.value });
  };
  selectedMcqType = (e) => {
    this.setState({ McqTypeBank: e.target.value });
  };

  componentDidMount() {
    var range_bank_edit = JSON.parse(sessionStorage.getItem("range_bank_edit"));
    this.setState({
      question: range_bank_edit.question,
      maxRange: range_bank_edit.max_value,
      minRange: range_bank_edit.min_value,
      edit_id: range_bank_edit.id,
    });
  }

  submit = (e) => {
    var data = {
      sid: ud.main_id,
      question: this.state.question,
      max_value: this.state.maxRange,
      min_value: this.state.minRange,
      id: this.state.edit_id,
    };
    if (data.question == "" || data.max_value == "" || data.min_value == "") {
      swal("Question, Max, And Min Is Always Compulsory.", "", "warning");
      return;
    } else if (Number(data.min_value) == Number(data.max_value)) {
      swal("Minimum Value and Maximum Value should not be the same.", "", "warning");
      return;
    }
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    let _this = this;
    axios
      .post(`${SERVER_IP}/bank/RangeUpdate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message);
            window.location.href = "/create/rangebanklist";
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.submit();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  render() {
    return (
      <div>
        <div class="xp-breadcrumbbar">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <h4 class="xp-page-title">
                <BackBtn /> Edit Range Library
              </h4>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="xp-breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <i>
                        <HomeIcon />
                      </i>
                    </a>
                  </li>
                  <li
                    class="breadcrumb-item active"
                    onClick={() => (window.location.href = "/create/rangebanklist")}
                    aria-current="page"
                  >
                    List Range Library
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="xp-contentbar p-30">
          <div className="row">
            <div className="col-lg-12">
              <div className="card document_gradient_border m-b-30 padding-0">
                <div className="card-header border-radius-top-15 ">
                  <h5 className="card-title">Edit Range Library</h5>
                </div>
                <div className="card-body">
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label for="exampleInputEmail1">Question</label>
                      <input
                        type="text"
                        onChange={this.onChangeInput}
                        name="question"
                        value={this.state.question}
                        className="form-control"
                        placeholder="Enter Question"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label for="exampleInputEmail1">Minimum Value</label>
                      <input
                        type="number"
                        onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                        onChange={this.onChangeInput}
                        name="minRange"
                        value={this.state.minRange}
                        className="form-control"
                        placeholder="Enter Min Range"
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label for="exampleInputEmail1">Maximum Value</label>
                      <input
                        type="number"
                        onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                        onChange={this.onChangeInput}
                        name="maxRange"
                        value={this.state.maxRange}
                        className="form-control"
                        placeholder="Enter Max Range"
                      />
                    </div>
                  </div>

                  <button onClick={this.submit} className="btn btn-primary mt-3">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default EditRangeBank;
